/* eslint-env browser */

(function () {
    const PORTAL_REFERRERS = ['partner', 'provider', 'partner-portal', 'provider-portal'];

    function normalizeReferrerCode(value) {
        const normalized = String(value || '').trim();
        const normalizedLowercase = normalized.toLowerCase().replace(/[\s_]+/g, '-');

        if (!normalized || PORTAL_REFERRERS.includes(normalizedLowercase)) {
            return null;
        }

        return normalized;
    }

    function getActiveReferrerCode() {
        if (typeof window === 'undefined') {
            return null;
        }

        try {
            const currentUrl = new URL(window.location.href);
            const referrers = currentUrl.searchParams.getAll('referrer');

            for (const referrer of referrers) {
                const referrerCode = normalizeReferrerCode(referrer);

                if (referrerCode) {
                    return referrerCode;
                }
            }
        } catch (error) {
            return null;
        }

        return null;
    }

    function shouldPropagateReferrer(link) {
        const href = link.getAttribute('href') || '';

        if (!href || href.startsWith('#')) {
            return false;
        }

        let resolvedUrl;

        try {
            resolvedUrl = new URL(href, window.location.href);
        } catch (error) {
            return false;
        }

        if (!['http:', 'https:'].includes(resolvedUrl.protocol)) {
            return false;
        }

        return resolvedUrl.hostname.replace(/^www\./i, '') === 'guidestination.com';
    }

    function applyReferrerToLink(link, referrerCode) {
        if (!shouldPropagateReferrer(link)) {
            return;
        }

        try {
            const resolvedUrl = new URL(link.getAttribute('href') || '', window.location.href);
            resolvedUrl.searchParams.set('referrer', referrerCode);
            link.setAttribute('href', resolvedUrl.toString());
        } catch (error) {
            // Ignore invalid URLs and leave the original link untouched.
        }
    }

    function rewriteMatchingLinks(root, referrerCode) {
        if (!root || !referrerCode) {
            return;
        }

        if (root instanceof Element && root.matches('a[href]')) {
            applyReferrerToLink(root, referrerCode);
        }

        if (typeof root.querySelectorAll !== 'function') {
            return;
        }

        root.querySelectorAll('a[href]').forEach(function (link) {
            applyReferrerToLink(link, referrerCode);
        });
    }

    function observeDynamicLinks(referrerCode) {
        if (!document.body || typeof MutationObserver === 'undefined') {
            return;
        }

        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (node) {
                    if (!(node instanceof Element)) {
                        return;
                    }

                    rewriteMatchingLinks(node, referrerCode);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        const referrerCode = getActiveReferrerCode();
        if (!referrerCode) {
            return;
        }

        rewriteMatchingLinks(document, referrerCode);
        observeDynamicLinks(referrerCode);
    });
})();
